// Copyright (c) 2018 Deere & Company

import * as busyCounter from '../../../../sharedmodules/action-creators/busy-counter';
import actions from '../../../../sharedmodules/actions-list';
import { getLatestPerUnitMeasurements } from '../repositories';

export const readLatestPerUnitMeasurements = (getAccessToken, pin) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const latestPerUnitMeasurements = await getLatestPerUnitMeasurements(getAccessToken, pin);

        dispatch({
            latestPerUnitMeasurements,
            type: actions.UPDATE_LATEST_PER_UNIT_MEASUREMENTS,
        });

    } catch (error) {

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};

export const resetLatestPerUnitMeasurements = () => (dispatch) => dispatch({
    type: actions.RESET_LATEST_PER_UNIT_MEASUREMENTS,
});
